<template>
  <div class="principal" v-loading="soc.waitingUpdate">
    <div :class="selectedItem" @click="selectItem">
      <el-row class="socInfoContainer">
        <div :class="clientIcon">
          <i class="fas fa-home" aria-hidden="true"></i>
        </div>
        <el-col :span="24">
          <el-tooltip v-if="['6','7','8'].includes(suborder.geo_state)"
                      :class="pinLinner"  placement="top">
            <div slot="content">Estado de geocodificación
              <span class="focus small">
                    {{suborder.geo_name}}
                    </span>
              Modificado por
              <span class="focus small">
                    {{suborder.email | validateGeoUser}}
                    </span>
            </div>
            <span class="fa-stack fa-1x">
              <i class="far fa-map fa-stack-1x"></i>
              <i class="fas fa-hand-point-down fa-stack-1x cornered"></i>
            </span>
          </el-tooltip>
          <el-tooltip v-else :class="pinLinner" placement="top">
            <div slot="content">Estado de geocodificación
              <span class="focus small">
                    {{suborder.geo_name}}
                    </span>
            </div>
            <span v-if="['9'].includes(suborder.geo_state)" class="fa-stack fa-1x">
              <i class="fas fa-map-marker-alt fa-stack-1x orange fixed"></i>
              <i class="fas fa-slash fa-stack-1x cornered gray-slash"></i>
            </span>
            <i v-else-if="['4'].includes(suborder.geo_state)"
               class="fas fa-map orange" aria-hidden="true"></i>
            <i v-else
               class="fas fa-map-marked-alt" aria-hidden="true"></i>
          </el-tooltip>
          <el-tooltip :class="pinLinner" placement="top">
            <div slot="content">Latitud y Longitud<br/>
              <span class="focus small">
                    {{suborder.latitude}}, {{suborder.longitude}}
                    </span>
            </div>
            <i class="fas fa-map-pin" aria-hidden="true"></i>
          </el-tooltip>
          <el-popover
            :class="pinLinner"
            placement="bottom"
            title="Ejemplos de compras con este punto"
            width="710"
            style="padding-top: 3px;"
            trigger="click">
            <el-table :data="suborder.gridData" v-loading="exampleLoading">
              <el-table-column width="120"
                               property="suborders_code" label="suborden"></el-table-column>
              <el-table-column width="150"
                               label="dirección">
                                <template slot-scope="scope">
                                  <el-popover trigger="hover" placement="top">
                                    <p>Dirección: {{ scope.row.dp_address }}</p>
                                    <div slot="reference"
                                         class="column-ellipsis"
                                         style="width: 140px;">
                                      {{ scope.row.dp_address }}
                                    </div>
                                  </el-popover>
                                </template>
              </el-table-column>
              <el-table-column width="120" label="fecha pactada">
                <template slot-scope="scope">{{ scope.row.date | DateOnly}}</template>
              </el-table-column>
              <el-table-column width="100"
                               label="cliente">
                                <template slot-scope="scope">
                                  <el-popover trigger="hover" placement="top" style="height: 30px;">
                                    <p>Nombre: {{ scope.row.customer_fullname }}</p>
                                    <div slot="reference"
                                         class="column-ellipsis"
                                         style="width: 90px;">
                                      {{ scope.row.customer_fullname }}
                                    </div>
                                  </el-popover>
                                </template>
              </el-table-column>
              <el-table-column width="100"
                               property="customer_rut" label="rut"></el-table-column>
              <el-table-column width="120"
                               property="customer_phone" label="teléfono"></el-table-column>
            </el-table>
            <el-button class="button-linner" slot="reference" v-on:click="clickButton">
              <i class="fas fa-user"></i>
            </el-button>
          </el-popover>
          <el-tag class="locality-tag"
                  :color="customColor"
                  size="mini"
                  effect="dark"><b>{{ suborder.locality }}</b></el-tag>
          <p class="value-style">{{suborder.address}}</p>
          <h3 class="key-style">Dirección</h3>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>

import moment from 'moment';
import { apiRequest } from '../../../backend/vue-axios/axios';

export default {
  name: 'geo-soc-ul',
  props: {
    suborder: {
      type: Object,
    },
    dateRange: {
      type: Object,
    },
  },
  data() {
    return {
      soc: this.suborder,
      newPage: null,
      loadingExamples: false,
      exampleLoading: false,
      gridData: [{
        suborder: '123123123',
        address: 'New York City',
        date: '2016-05-02',
        name: 'Jack',
        rut: '111111-1',
        phone: '09-1231231',
      }],
    };
  },
  filters: {
    validateGeoUser(email) {
      if (email === 'admin@falabella.cl') {
        return 'desconocido';
      }
      return email;
    },
    phone(number) {
      if (number !== '') {
        return number;
      }
      return '-';
    },
    /**
     * @return {string}
     */
    DateOnly(date) {
      return moment(date).format('DD-MM-YYYY');
    },
  },
  computed: {
    pinLinner() {
      if (this.suborder.selected) {
        return 'pin-linner selected';
      }
      return 'pin-linner';
    },
    selectedItem() {
      if (this.suborder.selected) {
        return 'socInfoCard selected';
      }
      return 'socInfoCard';
    },
    extraInfo() {
      if (this.suborder.selected) {
        return 'socInfoContainer extraInfo selected';
      }
      return 'socInfoContainer extraInfo';
    },
    clientIcon() {
      if (this.suborder.selected) {
        return 'clientIcon selected';
      }
      return 'clientIcon';
    },
    customColor() {
      if (this.suborder.selected) {
        return '#AAD500';
      }
      return '#a5a5a5';
    },
  },
  methods: {
    clickButton(event) {
      event.stopPropagation();
      if (this.suborder.gridData.length === 0) {
        this.exampleLoading = true;
        apiRequest({
          module: 'geocoding',
          service: 'get_point_examples',
          params: {
            points_id: this.suborder.point_id,
            time_init: this.dateRange.dateFrom,
            time_end: this.dateRange.dateUp,
          },
        }).then((response) => {
          this.exampleLoading = false;
          this.$emit('AddExamples', this.suborder.point_id, response.data);
        }).catch(() => {
          this.$notify.error({
            title: 'Error',
            message: 'Error al obtener puntos',
          });
          this.exampleLoading = false;
        });
      }
    },
    selectItem() {
      if (!this.soc.waitingUpdate) {
        this.$emit('selected');
      }
    },
  },
  watch: {
    suborder() {
      this.soc = this.suborder;
    },
  },
};
</script>

<style lang="scss" scoped>
  .principal {
    border-bottom: 2px solid $fb-grey-light-84;
  }
  .socInfoCard {
    // border-top: 1px solid $fb-grey-light-84;
    // border-right: 1px solid $fb-grey-light-84;
    // border-left: 1px solid $fb-grey-light-84;
    padding: 10px 15px;
    background: white;
    height: 30px;
    transition: box-shadow .3s;
  }
  .socInfoCard.selected {
    background:#fbfbfb;
    padding: 10px 15px;
    box-shadow:
      inset 0 11px 8px -10px #ccc,
      inset 0 -11px 8px -10px #ccc;
    transition: height .4s;
    .key-style {
      margin-bottom: 10px;
    }
  }
  .socInfoContainer {
    display: flex;
  }
  .clientIcon {
    margin-top: 10px;
    height: 5px;
    width: 35px;
    background: white;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    color: #a5a5a5;
    font-size: 20px;
  }
  .button-linner {
    color: #a5a5a5;
  }
  .clientIcon.selected {
    color: $fb-green;
  }
  .value-style {
    font-weight: 400;
    font-size: 13px;
    margin-top: 0;
    margin-bottom: 0;
    margin-left: 8px;
    max-width: calc(100% - 140px);
    text-align: left;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .key-style {
    font-weight: 700;
    font-size: 8px;
    color: #AAD500;
    margin-bottom: 0;
    margin-top: 0;
    margin-left: 8px;
    text-align: left;
    text-transform: uppercase;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .button-linner{
    border: 0;
    padding: 0;
  }
  .column-ellipsis {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .pin-linner{
    float: right;
    margin-top: 2px;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: center;
    margin-left: 5px;
    padding-top: 5px;
    color: #a5a5a5;
  }
  .pin-linner.selected{
    color: #AAD500
  }
  .focus {
    text-transform: uppercase;
    font-weight: 900;
    color: #AAD500;
    &.small {
      display: block;
      font-style: italic;
      margin-top: 0.5em;
      font-size: 0.85em;
    }
  }
  .cornered{
    color: #a5a5a5;
    position: absolute;
    line-height: 1em;
    //text-shadow: 1px 1px 1px #000;
  }
  .gray-slash {
    color: #a5a5a5;
  }
  .fixed {
    position: absolute;
    line-height: 1em;
  }
  .orange {
    color: #ff9100 !important;
  }
  i {
    width: 16px;
  }
  .fa-stack {
    width: 16px;
  }
  .locality-tag{
    float: right;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    border-color: #ffffff;
    margin-left: 10px;
    margin-top: 3px;
    max-width: 160px;
  }
</style>
